module.exports = __webpack_public_path__ + "img/voucher_desktop.e104f572.svg";